import { css } from 'styled-components';

export const statuses = {
    success: css`
        color: var(--plasma-field-success-color);
    `,
    warning: css`
        color: var(--plasma-field-warning-color);
    `,
    error: css`
        color: var(--plasma-field-error-color);
    `,
};
